var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap tax_invoice_request_detail_pop",
      staticStyle: { width: "600px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(_vm._s(_vm.$t("msg.ADD20260813.001"))),
        ]),
        _c("div", { staticClass: "content_box" }, [
          _c("table", { staticClass: "tbl_row" }, [
            _vm._m(0),
            _c("tbody", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.013")))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.invMethodNm))]),
              ]),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.012")))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.emlAddr))]),
              ]),
            ]),
          ]),
          _c("table", { staticClass: "tbl_list font_sm gridtype mt10" }, [
            _vm._m(1),
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.026")))]),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.027")))]),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.028")))]),
              ]),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.detailList, function (row, idx) {
                return _c("tr", { key: `${row.blNo}_${idx}` }, [
                  _c("td", { staticClass: "text_center" }, [
                    _vm._v(_vm._s(row.blNo)),
                  ]),
                  _c("td", { staticClass: "text_center" }, [
                    _vm._v(_vm._s(_vm.getStatusNm(row.apvStsCd))),
                  ]),
                  _c("td", [_vm._v(_vm._s(row.reqRsps || "-"))]),
                ])
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "mt10 text_center" }, [
          _c(
            "a",
            {
              staticClass: "button gray lg",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.034")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "160px" } }),
      _c("col", { attrs: { width: "*" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "35%" } }),
      _c("col", { attrs: { width: "25%" } }),
      _c("col", { attrs: { width: "40%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }